import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Client  from 'chekin-sdk';


class ChekinPro {

  
  createReactElement(targetNode:string){
    const reactElement = React.createElement(App, {}, 'My First React Code');
    ReactDOM.render(reactElement, document.getElementById(targetNode), ()=>{});
    return reactElement;
  }

}

export  {ChekinPro};

